const { makeStyles } = require("@material-ui/core");

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '100%',
        padding: theme.spacing(2),
        color: theme.palette.secondary.main,
    },
    logoSection:{
        marginTop: 80,
    },
    curvedTitle: {
        fontFamily: 'Montserrat',
        fontSize: '1.2rem',
        '& span': {
            position: 'absolute'
        },
    },
    logo: {
        marginTop: -25
    },
    logoCaption: {
        textAlign: 'center',
        fontSize: '0.9rem',
        fontWeight: 'bold',
        fontFamily: 'Montserrat',
        letterSpacing: '0.15rem'
    },
    footer: {
        width: '100%',
		height: 110,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between'
    },
	versioNumber: {
		textAlign: 'right'
	}
}));

export default useStyles;
